// extracted by mini-css-extract-plugin
module.exports = {"container":"src-screens-Chats-components-Rating-Rating-module__container--3dfvn","ratingRoot":"src-screens-Chats-components-Rating-Rating-module__ratingRoot--2XLfd"};